import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, onUnmounted, watch, getCurrentInstance, reactive } from '../../../adapter-vue';
import TUIChatEngine, { IConversationModel, TUIStore, StoreName, TUIChatService } from '@tencentcloud/chat-uikit-engine';
import TUICore, { ExtensionInfo, TUIConstants } from '@tencentcloud/tui-core';
import EmojiPicker from './emoji-picker/index.vue';
import ImageUpload from './image-upload/index.vue';
import FileUpload from './file-upload/index.vue';
import VideoUpload from './video-upload/index.vue';
import Evaluate from './evaluate/index.vue';
import Words from './words/index.vue';
import ToolbarItemContainer from './toolbar-item-container/index.vue';
import UserSelector from './user-selector/index.vue';
import { isPC, isH5, isUniFrameWork } from '../../../utils/env';
import TUIChatConfig from '../config';
import { enableSampleTaskStatus } from '../../../utils/enableSampleTaskStatus';
import { ToolbarDisplayType } from '../../../interface';
import interview from '@/components/interview/interview';
import axios from "@/libs/api.request";
import { setScore } from '@/api/data';
import store from '@/store';

interface IProps {
  displayType: ToolbarDisplayType;
}
interface IEmits {
  (e: 'scrollToLatestMessage'): void;
  (e: 'changeToolbarDisplayType', type: ToolbarDisplayType): void;
  (e: 'insertEmoji', emoji: any): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    displayType: { default: 'none' }
  },
  emits: ["scrollToLatestMessage", "changeToolbarDisplayType", "insertEmoji"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'scrollToLatestMessage'): void;
  (e: 'changeToolbarDisplayType', type: ToolbarDisplayType): void;
  (e: 'insertEmoji', emoji: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { displayType: ToolbarDisplayType }



const state = reactive({
  isShowModal: false,
  to: ''
});

const h5Dialog = ref<HTMLElement>();
const currentConversation = ref<IConversationModel>();
const isGroup = ref<boolean>(false);
const selectorShowType = ref<string>('');
const userSelectorRef = ref();
const emojiPickerRef = ref<InstanceType<typeof EmojiPicker>>();
const currentUserSelectorExtension = ref<ExtensionInfo>();
const currentExtensionList = ref<ExtensionInfo[]>([]);

onMounted(() => {
  TUIStore.watch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdate
  });
  if (localStorage.getItem('videoCall')) {
    localStorage.removeItem('videoCall');
    onCallExtensionClicked(extensionListShowInStart.value[1], 2);
  }
});

onUnmounted(() => {
  TUIStore.unwatch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdate
  });
});

watch(
  () => props.displayType,
  newValue => {
    if (newValue === 'none') {
      emojiPickerRef.value?.closeEmojiPicker();
    } else {
      emits('scrollToLatestMessage');
    }
  }
);
const askResume = () => {
  store.getters.firstTalk && setScore('消息-回复');
  setScore('聊天-求简历');
  TUIChatService.sendCustomMessage({
    payload: {
      data: JSON.stringify({
        // 评价类消息标识字段
        businessID: 'askResume',
        text: '请求一份简历'
      }),
      description: '收到了一份简历请求'
    }
  });
};
const yuemianshi = () => {
  let conversation = TUIStore.getConversationModel(TUIStore.getData(StoreName.CONV, 'currentConversationID'));
  if (conversation.type === TUIChatEngine.TYPES.CONV_C2C) {
    state.to = TUIStore.getData(StoreName.CONV, 'currentConversationID').replace('C2C', '');
    state.isShowModal = true;
  }
};
const sent = item => {
  state.isShowModal = false;
};
const jobChat = (toID, jobID) => {
  axios
    .request({
      url: 'front/v1/chat',
      method: 'post',
      data: {
        to: toID,
        jobId: jobID
      }
    })
};
const getExtensionList = (conversationID: string) => {
  if (!conversationID) {
    return (currentExtensionList.value = extensionList);
  }
  const chatType = TUIChatConfig.getChatType();
  const options: any = {
    chatType
  };
  // 向下兼容，callkit 没有chatType 判断时，使用 filterVoice、filterVideo 过滤
  if (chatType === 'customerService') {
    options.filterVoice = true;
    options.filterVideo = true;
    enableSampleTaskStatus('customerService');
  }
  currentExtensionList.value = [...TUICore.getExtensionList(TUIConstants.TUIChat.EXTENSION.INPUT_MORE.EXT_ID, options)];
};

const onCurrentConversationUpdate = (conversation: IConversationModel) => {
  if (conversation?.conversationID && currentConversation.value?.conversationID !== conversation?.conversationID) {
    getExtensionList(conversation?.conversationID);
  }
  currentConversation.value = conversation;
  if (currentConversation?.value?.type === TUIChatEngine.TYPES.CONV_GROUP) {
    isGroup.value = true;
  } else {
    isGroup.value = false;
  }
};

// extensions
const extensionList: ExtensionInfo[] = [...TUICore.getExtensionList(TUIConstants.TUIChat.EXTENSION.INPUT_MORE.EXT_ID)];

// 按展示位置分类 extensionList （注意：仅 web 端 区分展示位置在 从 start 开始和 从 end 开始，在移动端不生效）
const extensionListShowInStart = computed((): ExtensionInfo[] =>
  isPC ? currentExtensionList.value.filter((extension: ExtensionInfo) => extension?.data?.name !== 'search') : currentExtensionList.value
);

const extensionListShowInEnd = computed<ExtensionInfo[]>(() => {
  // if (isPC) {
  //   const searchExtension = currentExtensionList.value.find(extension => extension?.data?.name === 'search');
  //   return searchExtension ? [searchExtension] : [];
  // }
  return [];
});

// handle extensions onclick
const onExtensionClick = (extension: ExtensionInfo) => {
  switch (extension?.data?.name) {
    case 'voiceCall':
      onCallExtensionClicked(extension, 1);
      break;
    case 'videoCall':
      onCallExtensionClicked(extension, 2);
      break;
    default:
      extension?.listener?.onClicked(currentConversation.value?._conversation);
      break;
  }
  store.getters.firstTalk && setScore('消息-回复');
};

const onCallExtensionClicked = (extension: ExtensionInfo, callType: number) => {
  selectorShowType.value = extension?.data?.name;
  if (currentConversation?.value?.type === TUIChatEngine.TYPES.CONV_C2C) {
    extension.listener?.onClicked?.({
      userIDList: [currentConversation?.value?.conversationID?.slice(3)],
      type: callType
    });
  } else if (isGroup.value) {
    currentUserSelectorExtension.value = extension;
    userSelectorRef?.value?.toggleShow && userSelectorRef.value.toggleShow(true);
  }
};

const genExtensionIcon = (extension: any) => {
  return extension?.icon;
};

const genExtensionText = (extension: any) => {
  return extension?.text;
};

const onUserSelectorSubmit = (selectedInfo: any) => {
  currentUserSelectorExtension.value?.listener?.onClicked?.(selectedInfo);
  currentUserSelectorExtension.value = undefined;
};

const onUserSelectorCancel = () => {
  currentUserSelectorExtension.value = undefined;
};

const insertEmoji = (emojiObj: object) => {
  emits('insertEmoji', emojiObj);
};

const dialogShowInH5 = (dialogDom: any) => {
  if (!isH5) {
    return;
  }
  h5Dialog.value?.appendChild && h5Dialog.value?.appendChild(dialogDom);
};

const dialogCloseInH5 = (dialogDom: any) => {
  if (!isH5) {
    return;
  }
  if (dialogDom) {
    h5Dialog.value?.removeChild && h5Dialog.value?.removeChild(dialogDom);
  }
};

return { __sfc: true,props, state, emits, h5Dialog, currentConversation, isGroup, selectorShowType, userSelectorRef, emojiPickerRef, currentUserSelectorExtension, currentExtensionList, askResume, yuemianshi, sent, jobChat, getExtensionList, onCurrentConversationUpdate, extensionList, extensionListShowInStart, extensionListShowInEnd, onExtensionClick, onCallExtensionClicked, genExtensionIcon, genExtensionText, onUserSelectorSubmit, onUserSelectorCancel, insertEmoji, dialogShowInH5, dialogCloseInH5, EmojiPicker, ImageUpload, FileUpload, VideoUpload, Words, ToolbarItemContainer, UserSelector, isPC, isH5, isUniFrameWork, interview }
}

})